/**
 * Set the thumbnail image of the page into context with this key
 * @example setContext(thumbnailImageContextKey, "<path-to-image>");
 */
export const thumbnailImageContextKey = "keywords";
